import { render } from "./AgentUpdate.vue?vue&type=template&id=394d8440"
import script from "./AgentUpdate.vue?vue&type=script&lang=js"
export * from "./AgentUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__